import React from 'react'
import StartPage from '../components/Start';

const Start = () => {
    return (
        <>
            <StartPage/>
        </>
    )
}

export default Start
